// import { get } from 'lodash'

export default function(fields, fileUrl, sectionId, category) {
  return {
    ...fields,
    section: {
      value: sectionId
    },
    category: {
      value: category
    },
    fileUrl
  }
}

